/** Single source of truth for product branding (override via REACT_APP_PRODUCT_NAME). */
export const APP_NAME = process.env.REACT_APP_PRODUCT_NAME || 'PowerFlow';

export const APP_TAGLINE =
  'Streamline your workflow and boost productivity';

export const APP_DESCRIPTION =
  `${APP_NAME} brings clients, projects, tasks, and team workflows into one beautiful workspace.`;
